import {
  is_development,
  log,
  is_mobile,
  is_authenticated,
  get_config,
  get_availability,
  format_price,
  get_site_name,
  get_object_field,
  show_developer_tools,
} from "./commons";

/**
 * Checks if an element's text content is truncated (ellipsis visible)
 * Works for both single-line (text-truncate) and multi-line (line-clamp) truncation
 * @param {HTMLElement} element - The DOM element to check
 * @returns {boolean} - True if text is truncated, false otherwise
 */
function is_text_truncated(element) {
  if (!element) return false;
  const is_horizontally_truncated = element.scrollWidth > element.clientWidth;
  const is_vertically_truncated = element.scrollHeight > element.clientHeight;
  return is_horizontally_truncated || is_vertically_truncated;
}

const scroll_window = (position = {}) => {
  try {
    if (!window) {
      return;
    }

    const scroll = window.scroll || window.scrollTo;
    if (!scroll) {
      return;
    }

    const use_object = Object.keys(position).some((key) =>
      ["top", "left", "behavior"].includes(key),
    );
    if (use_object) {
      scroll(position);
      return;
    }
    const { x = 0, y = 0 } = position;
    scroll(x, y);
  } catch (e) {
    log("scroll_window", e);
  }
};

export default {
  methods: {
    is_development: is_development,
    log: log,
    is_mobile: is_mobile,
    is_authenticated: is_authenticated,
    get_config: get_config,
    get_availability: get_availability,
    format_price: format_price,
    get_site_name: get_site_name,
    is_text_truncated: is_text_truncated,
    get_object_field,
    scroll_window,
    show_developer_tools,
    scroll_top() {
      scroll_window({ top: 0, behavior: "smooth" });
    },
  },
};
